import React from 'react'
import pStoryImg from "../../../img/pstory.png"
import useIsInViewport from 'use-is-in-viewport'

function Plantstory() {
	const [isInViewport, targetRef] = useIsInViewport()
	var classes = `${isInViewport ? "visible" : "hidden"}`
	return ( 
		<div ref={targetRef} className={classes}>
			<div className="project">
				<img alt="plantstory" src={pStoryImg}/>
				<div className="info">
				<h2>Plantstory 🌱</h2>
				<div className="links">
					<a href="https://plantstory.netlify.app/">Visit Site</a> 
					<a href="https://www.youtube.com/watch?v=SrtUxy3YXQA&feature=youtu.be">Demo</a> 
					<a href="https://github.com/jguzz/plantstory-client">Frontend</a> 
					<a href="https://github.com/jguzz/Plantstory_api">Backend</a> 
				</div>
					<h4>Social media website that allows users to categorize and share their collection of plants.</h4>
				<p>
					- Single page frontend application built using <strong>React</strong> and designed with <strong>Material-UI</strong>.<br/>
					- Utilized <strong>React Router</strong> for client side routing as well as nested routes.<br/>
					- <strong>Active Storage</strong> for photo storage in the backend, stored to Amazon S3 Web Services.<br/>
					- Created a <strong>Rails API</strong> following <strong>MVC</strong> patterns using Postgres. <br/>
					- Deployed and hosted on <strong>Netlify</strong> for frontend and <strong>Heroku</strong> for the backend.
				</p>
				</div>
			</div>
	  	</div>
	  )
}

export default Plantstory